module.exports = __webpack_public_path__ + "img/back.2c8995c9.jpg";